import contactSideBarFields from 'molecules/ContactSideBar/config';
import { imageField } from 'molecules/Image/config';

import type { Input } from '@builder.io/sdk';

export const sideNavHeroFields = [
  {
    name: 'backgroundColor',
    type: 'string',
    enum: ['white', 'grey'],
    defaultValue: 'white',
  },
  {
    name: 'options',
    type: 'list',
    subFields: [
      {
        name: 'eyebrow',
        type: 'string',
      },
      {
        name: 'body',
        type: 'richText',
      },
      {
        name: 'ctas',
        type: 'list',
        subFields: [
          {
            name: 'label',
            type: 'string',
          },
          {
            name: 'link',
            type: 'string',
          },
          {
            name: 'type',
            type: 'string',
            enum: ['arrow', 'teal-button', 'grey-button'],
          },
        ],
      },
    ],
  },
  {
    name: 'contactSideBar',
    type: 'object',
    subFields: [...contactSideBarFields],
  },
  imageField('borderBottomImage'),
] as const satisfies DeepReadonly<Input[]>;

const sideNavHeroConfig = {
  name: 'SideNav Hero',
  inputs: sideNavHeroFields,
};

export type SideNaveHeroProps = GenerateBuilder<typeof sideNavHeroFields>;

export default sideNavHeroConfig;
